/** @typedef {import('./ModalHelper.svc')} Types */

export class ModalHelper {
	constructor($uibModal) {
		'ngInject';
		this.uibModal = $uibModal;
	}

	/**
	 * Native <dialog> implementation of showModal.
	 * Accepts the same params shape as showModal for easy migration.
	 * Returns a Promise that resolves on close and rejects on dismiss.
	 * @param {Types.ShowDialogParams} paramsObj
	 * @returns {Promise<void>}
	 */
	showDialog(paramsObj = {}) {
		const {title = null, body = null, allowHtml = false, closeBtn = false, dismissBtn = false} = paramsObj;

		const _closeBtn = !closeBtn && !dismissBtn ? {label: 'Close', disabled: false} : closeBtn;
		const BTN = 'btn';
		const closeBtnConfig =
			_closeBtn && !_closeBtn.classes
				? Object.assign({}, _closeBtn, {classes: `${BTN} btn-primary`})
				: Object.assign({}, _closeBtn);
		const dismissBtnConfig =
			dismissBtn && !dismissBtn.classes
				? Object.assign({}, dismissBtn, {classes: `${BTN} btn-outline-primary`})
				: dismissBtn
					? Object.assign({}, dismissBtn)
					: null;

		return new Promise((resolve, reject) => {
			const dialog = document.createElement('dialog');
			dialog.classList.add('modal-alert-dialog');

			// header
			if (title) {
				const header = document.createElement('div');
				header.classList.add('modal-header');
				const heading = document.createElement('h3');
				heading.classList.add('modal-title');
				heading.textContent = title;
				header.appendChild(heading);
				dialog.appendChild(header);
			}

			// body
			if (body) {
				const bodyEl = document.createElement('div');
				bodyEl.classList.add('modal-body');
				if (allowHtml) {
					bodyEl.innerHTML = body;
				} else {
					bodyEl.textContent = body;
				}
				dialog.appendChild(bodyEl);
			}

			// footer
			const footer = document.createElement('div');
			footer.classList.add('modal-footer');

			if (dismissBtnConfig && dismissBtnConfig.disabled === false) {
				const dismissButton = document.createElement('button');
				dismissButton.className = dismissBtnConfig.classes;
				dismissButton.textContent = dismissBtnConfig.label;
				dismissButton.addEventListener('click', () => {
					dialog.close('dismiss');
					dialog.remove();
					reject('dismiss');
				});
				footer.appendChild(dismissButton);
			}

			if (closeBtnConfig && closeBtnConfig.disabled === false) {
				const closeButton = document.createElement('button');
				closeButton.className = closeBtnConfig.classes;
				closeButton.textContent = closeBtnConfig.label;
				closeButton.addEventListener('click', () => {
					dialog.close('close');
					dialog.remove();
					resolve();
				});
				footer.appendChild(closeButton);
			}

			dialog.appendChild(footer);

			// ESC key closes and rejects (mirrors $uibModal keyboard:true default)
			dialog.addEventListener('cancel', event => {
				event.preventDefault();
				dialog.remove();
				reject('dismiss');
			});

			document.body.appendChild(dialog);
			dialog.showModal();
		});
	}

	/** @param {Types.ShowModalParams} paramsObj */
	showModal(paramsObj = {}) {
		const {
			size = 'md',
			keyboard = true,
			backdrop = true,
			title = null,
			body = null,
			closeBtn = false,
			dismissBtn = false,
		} = paramsObj;
		const _closeBtn = !closeBtn && !dismissBtn ? {label: 'Close', disabled: false} : closeBtn;
		const BTN = 'btn';
		const dismiss =
			dismissBtn && !dismissBtn.classes
				? Object.assign(dismissBtn, {classes: `${BTN} btn-outline-primary`})
				: Object.assign(dismissBtn, {classes: `${BTN} ${dismissBtn.classes}`});
		const close =
			_closeBtn && !_closeBtn.classes
				? Object.assign(_closeBtn, {classes: `${BTN} btn-primary`})
				: Object.assign(_closeBtn, {classes: `${BTN} ${_closeBtn.classes}`});
		return this.uibModal.open({
			keyboard,
			component: 'modalAlert',
			windowClass: 'modal-alert',
			size: `${size} modal-dialog-centered`,
			backdrop,
			resolve: {
				data: () => ({title, body, dismiss, close}),
			},
		});
	}
}
//
let compMod = angular.module('mod.svc.ModalHelperSvc', []).service('ModalHelperSvc', ModalHelper);
export default (compMod = compMod.name);
